function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Outline_Old_Icons",
  "data-name": "Outline Old Icons"
}, React.createElement("path", {
  d: "M9.86,13.4a.48.48,0,0,1,0,.7L6.68,17.29a3.51,3.51,0,0,1-4.95,0L1,16.58a3.51,3.51,0,0,1,0-4.95L5.62,7a3.51,3.51,0,0,1,5,0l.71.71a.5.5,0,0,1-.71.71l-.71-.71a2.5,2.5,0,0,0-3.53,0l-4.6,4.6a2.5,2.5,0,0,0,0,3.53l.71.71a2.56,2.56,0,0,0,3.53,0L9.16,13.4A.48.48,0,0,1,9.86,13.4ZM17.29,1.73,16.58,1a3.51,3.51,0,0,0-4.95,0L8.45,4.2a.5.5,0,0,0,.71.71l3.18-3.18a2.49,2.49,0,0,1,3.53,0l.71.71a2.5,2.5,0,0,1,0,3.53L12,10.57a2.57,2.57,0,0,1-3.54,0,.5.5,0,0,0-.71,0,.51.51,0,0,0,0,.71,3.51,3.51,0,0,0,4.95,0l4.6-4.6a3.51,3.51,0,0,0,0-4.95Z"
})));

var SvgLink = function SvgLink(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 18.31 18.31",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link.53a7365f.svg";
export { ForwardRef as ReactComponent };